// extracted by mini-css-extract-plugin
module.exports = {"Marquee":"Marquee_Marquee__aEPR3"};